/**
 * Spanish legal copy — approved translation (tú informal, consistent).
 * Source: /app/drafts/legal_translations/es.md with Laura's refinements:
 *   - Terms §1: "proporcionados por los usuarios" → "que proporcionas"
 *   - Privacy §4: "del usuario" → "tuyo" (tú consistency)
 */

const es = {
    terms: {
        preamble: [
            { type: "para", text: 'Other Side es una plataforma digital operada por Laura Stella, que opera bajo el nombre "Other Side".' },
        ],
        sections: [
            { number: 1, title: "Naturaleza del servicio", blocks: [
                { type: "para", text: "Other Side utiliza tecnologías de inteligencia artificial para generar experiencias simuladas basadas en los contenidos que proporcionas." },
                { type: "para", text: "Las interacciones generadas no representan comunicaciones reales ni implican la presencia o consciencia de la persona representada." },
            ]},
            { number: 2, title: "Requisitos de uso", blocks: [
                { type: "para", text: "Debes tener al menos 18 años y utilizar el servicio respetando las leyes aplicables." },
            ]},
            { number: 3, title: "Responsabilidad sobre los contenidos", blocks: [
                { type: "para", text: "Eres responsable de los contenidos que subes y declaras tener derecho a utilizarlos." },
            ]},
            { number: 4, title: "Personas representadas", blocks: [
                { type: "para", text: "Garantizas no violar derechos de terceros, incluyendo derechos relativos a personas fallecidas." },
            ]},
            { number: 5, title: "Uso prohibido", blocks: [
                { type: "para", text: "Está prohibido el uso del servicio con fines ilegales, fraudulentos o lesivos de los derechos de terceros." },
            ]},
            { number: 6, title: "Limitación de responsabilidad", blocks: [
                { type: "para", text: "Other Side no se responsabiliza por interpretaciones subjetivas, reacciones emocionales o uso indebido del servicio." },
            ]},
            { number: 7, title: "Interrupción", blocks: [
                { type: "para", text: "El servicio puede ser suspendido o limitado en caso de violaciones." },
            ]},
            { number: 8, title: "Tus derechos", blocks: [
                { type: "para", text: "Puedes solicitar acceso, modificación o eliminación de tus datos." },
            ]},
            { number: 9, title: "Modificaciones", blocks: [
                { type: "para", text: "Los términos pueden actualizarse en cualquier momento." },
            ]},
            { number: 10, title: "Ley aplicable", blocks: [
                { type: "para", text: "El servicio se rige por la normativa europea aplicable." },
            ]},
        ],
    },

    privacy: {
        preamble: [
            { type: "contact", label: "Responsable del tratamiento", value: 'Laura Stella, que opera bajo el nombre "Other Side"' },
            { type: "contact", label: "Email", value: "os.otherside.app@gmail.com", mailto: true },
        ],
        sections: [
            { number: 1, title: "Tipos de datos recogidos", blocks: [
                { type: "list", items: [
                    "Datos identificativos",
                    "Contenidos subidos (imágenes, audio, vídeo)",
                    "Datos biométricos (voz, imágenes)",
                    "Datos técnicos (IP, dispositivo, log)",
                ]},
            ]},
            { number: 2, title: "Finalidades", blocks: [
                { type: "list", items: [
                    "Prestación del servicio",
                    "Generación de contenidos IA",
                    "Seguridad y mejora",
                ]},
            ]},
            { number: 3, title: "Base jurídica", blocks: [
                { type: "list", items: [
                    "Consentimiento explícito",
                    "Ejecución del servicio",
                ]},
            ]},
            { number: 4, title: "Datos biométricos", blocks: [
                { type: "para", text: "Los datos biométricos se tratan solo previo tu consentimiento explícito." },
            ]},
            { number: 5, title: "Conservación", blocks: [
                { type: "para", text: "Los datos se conservan durante el tiempo necesario para el servicio." },
            ]},
            { number: 6, title: "Tus derechos", blocks: [
                { type: "para", text: "Acceso, rectificación, supresión, limitación, oposición." },
            ]},
            { number: 7, title: "Transferencias", blocks: [
                { type: "para", text: "Los datos pueden ser tratados en servidores situados en la Unión Europea o fuera de ella, respetando las normativas aplicables." },
            ]},
            { number: 8, title: "Seguridad", blocks: [
                { type: "para", text: "Se adoptan medidas técnicas y organizativas para proteger los datos." },
            ]},
            { number: 9, title: "Reclamaciones", blocks: [
                { type: "para", text: "Puedes dirigirte a la autoridad de protección de datos competente." },
            ]},
        ],
    },

    biometric: {
        preamble: [
            { type: "para", text: "Prestas consentimiento explícito al tratamiento de:" },
        ],
        sections: [
            { title: "Datos biométricos involucrados", blocks: [
                { type: "list", items: ["imágenes", "voz", "contenidos de audio y vídeo"] },
                { type: "para", text: "con el fin de crear la experiencia digital." },
            ]},
            { title: "Naturaleza del consentimiento", blocks: [
                { type: "para", text: "El consentimiento es:" },
                { type: "list", items: ["libre", "informado", "revocable"] },
            ]},
            { title: "Revocación", blocks: [
                { type: "para", text: "Puedes revocarlo en cualquier momento a través de la configuración de tu cuenta o mediante solicitud directa." },
            ]},
        ],
    },

    ai_notice: {
        preamble: [
            { type: "para", text: "Other Side utiliza sistemas de inteligencia artificial." },
        ],
        sections: [
            { title: "Las interacciones", blocks: [
                { type: "list", items: [
                    "son generadas artificialmente",
                    "pueden simular voz, estilo y contenidos",
                    "no representan comunicaciones reales",
                ]},
            ]},
            { title: "Límites del sistema", blocks: [
                { type: "para", text: "El servicio no recrea consciencia ni identidad real." },
                { type: "para", text: "Aceptas interactuar con un sistema de IA y comprendes sus límites." },
            ]},
        ],
    },

    memorial: {
        preamble: [
            { type: "para", text: "Other Side permite la creación de experiencias basadas en contenidos relativos a personas." },
        ],
        sections: [
            { number: 1, title: "Responsabilidad", blocks: [
                { type: "para", text: "Eres responsable de los contenidos que subes." },
            ]},
            { number: 2, title: "Personas fallecidas", blocks: [
                { type: "para", text: "Declaras tener derecho o autorización para utilizar los contenidos." },
            ]},
            { number: 3, title: "Derechos de los familiares", blocks: [
                { type: "para", text: "Las solicitudes de eliminación o modificación pueden ser realizadas por sujetos legitimados." },
            ]},
            { number: 4, title: "Denuncias", blocks: [
                { type: "para", text: "Other Side se reserva el derecho de eliminar contenidos cuestionados." },
            ]},
            { number: 5, title: "Limitaciones", blocks: [
                { type: "para", text: "El servicio no garantiza exactitud histórica ni representación real." },
            ]},
        ],
    },
};

export default es;
